__turbopack_context__.v({
  "blockRoot": "BlockOverflowCarousel-module-scss-module__pVDxCa__blockRoot",
  "button": "BlockOverflowCarousel-module-scss-module__pVDxCa__button",
  "buttonTransition": "BlockOverflowCarousel-module-scss-module__pVDxCa__buttonTransition",
  "buttons": "BlockOverflowCarousel-module-scss-module__pVDxCa__buttons",
  "content": "BlockOverflowCarousel-module-scss-module__pVDxCa__content",
  "fade-in": "BlockOverflowCarousel-module-scss-module__pVDxCa__fade-in",
  "fade-up": "BlockOverflowCarousel-module-scss-module__pVDxCa__fade-up",
  "flushBottom": "BlockOverflowCarousel-module-scss-module__pVDxCa__flushBottom",
  "flushTop": "BlockOverflowCarousel-module-scss-module__pVDxCa__flushTop",
  "inner": "BlockOverflowCarousel-module-scss-module__pVDxCa__inner",
  "isActive": "BlockOverflowCarousel-module-scss-module__pVDxCa__isActive",
  "isExtendedTop": "BlockOverflowCarousel-module-scss-module__pVDxCa__isExtendedTop",
  "isInView": "BlockOverflowCarousel-module-scss-module__pVDxCa__isInView",
  "isInitialPaint": "BlockOverflowCarousel-module-scss-module__pVDxCa__isInitialPaint",
  "isOverflowSlide": "BlockOverflowCarousel-module-scss-module__pVDxCa__isOverflowSlide",
  "nav": "BlockOverflowCarousel-module-scss-module__pVDxCa__nav",
  "root": "BlockOverflowCarousel-module-scss-module__pVDxCa__root",
  "slides": "BlockOverflowCarousel-module-scss-module__pVDxCa__slides",
  "text": "BlockOverflowCarousel-module-scss-module__pVDxCa__text",
});
